const dict = {
  chooseLang: "Choose language",
  agree: "Agree",

  //Licence
  instructions: "Instructions",
  step1: "Step 1: Scan the QR Code",
  locateqr: "Locate the QR code on your right.",
  useSmartphone:
    "Use your smartphone's camera or a QR code scanner app to scan it. This will take you to the next step.",
  step2: "Step 2: Enter Playlist Information",
  afterScan: "After scanning the QR code, you'll be prompted to enter your playlist information.",
  makeSure: "Make sure to fill in all the required fields.",
  step3: "Step 3: Return to the App",
  onceYou:
    "Once you've entered your playlist details, you can go back to the app and continue your experience.",
  refresh: "REFRESH",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "You don't have a Licence.",
  scanLicence: "Scan to buy licence.",
  noPlaylist: "You don't have any playlist",
  privacyBig: "PRIVACY MODE",
  scanToAddBig: "SCAN TO ADD PLAYLIST",
  scanToBuyBig: "SCAN TO BUY LICENCE",
  orVisit: "or visit",
  andenterdeviceID: "and enter this device id:",
  removePlaylist: "Remove Playlist",
  wantToRemove: "Do you want to remove ?",
  cancelBig: "CANCEL",
  loading: "Loading...",
  enablePMode: "Please enable Privacy Mode to continue watching.",
  killSwitchProtecting: "Kill Switch is protecting your privacy by blocking access when Privacy Mode is off.",
  kSwitchProtecionActive: "Kill Switch Protection Active",
  privacyMode: "Privacy Mode",
  ok: "OK",

  //Home
  bigLiveTv: "Live TV's",
  bigMovies: "Movies",
  bigSeries: "Series",
  //Channel-Menu
  noChannels: "This playlist has no channel data",
  searchChannels: "Search Channel",
  tapToPlay: "Tap to play the video stream.",
  categoryEmpty: "This category is empty",
  pinNotSet: "PIN Not Set",
  setPinNow: " Would you like to set up your PIN now?",
  preview: "PREVIEW",
  liveTv: "Live TV",
  addToFav: "Add to Favorites",
  removeFromFav: "Remove from Favorites",
  now: "Now:",
  nextPlaying: "Next Playing:",
  channels: "Channels",
  noChannelsFound: "No channels found",

  //Movies
  noMovies: "This playlist has no Movies data",
  searchMovies: "Search Movies",
  noFavMovies: "No favorite movies",
  //series
  noSeries: "This playlist has no series data",
  searchSeries: "Search Series",
  noFavSeries: "No favorite series",
  search: " Search",
  thereIsProblem: "There is a problem at the moment",
  tryAgainLater: "Please try again later.",
  series: "Series",
  movies: "Movies",
  noSeriesFound: "No series found",
  noMoviesFound: "No movies found",
  //entity
  play: "PLAY",
  playMovie: "Play Movie",
  recommendations: "Recommendations",
  //User Info
  userInfo: "User Info",
  aboutApp: "About App",
  //Userinfo
  account: "Account",
  subscriptions: "Subscriptions",
  privacyPilicy: "Privacy & Policy",
  languge: "Languge",
  english: "English",
  italian: "Italian",
  spanish: "Spanish",
  french: "French",
  german: "German",
  saudiArabia: "Arabic",
  chinese: "Chinese",
  greek: "Greek",
  turkish: "Turkish",
  change_pin: "Change PIN",
  kill_switch: "Kill Switch",
  device_info: "Device Information",
  unknown: "Unknown",

  //headers
  settings: "Settings",
  termsConditions: "Terms & Conditions",
  home: "Home",

  //license
  scanQrCode: "Scan QR Code to send a playlist",
  managePlaylist: "Manage Playlist",
  orVisitt: "Or visit",
  scanToAdd: "Scan to add playlist or visit",
  playlistNotValid: 'Your playlist is not valid.',

  //device info
  display: "Display",
  storage: "Storage",
  network: "Network",
  connection: "Connection",
  macAddress: "MAC Address:",
  deviceId: "Device ID:",
  pmInfo: "Privacy Mode Information",
  statusActive: "Status: Active",
  underMaintance: "Status: Under Maintenance",
  version: "Version:",
  lastBuildDate: "Last Build Date:",
  lastUpdated: "Last Updated: ",

  //kill switch
  enableKillSwitch: "Enable Kill Switch?",
  disableKillSwitch: "Disable Kill Switch?",
  whenEnabled: "When enabled, OrbixPlay will ONLY work when Privacy Mode is turned on.",
  withOrWithoutPM: "OrbixPlay will work normally with or without Privacy Mode.",
  extra_privacy_protection: " Extra Privacy Protection",
  pmOn: "• If Privacy Mode is ON: you can stream content securely",
  killSwitchDescription: "Kill Switch provides an extra layer of protection for maximum privacy.",
  pmOff: "• If Privacy Mode is OFF: the app will block access to protect your privacy",
  reenable: "You can re-enable it anytime for maximum security.",
  cancel: "Cancel",
  enable: "Enable",
  disable: "Disable",
  killSwitch: "Kill Switch – Extra Privacy Protection",
  ipHidden: "When you turn on Privacy Mode, your IP address is hidden and your connection goes through a secure system — similar to how a VPN works.",
  extraLayer: "The Kill Switch is an extra layer of protection: if you enable it, OrbixPlay will only work when Privacy Mode is turned on.",
  ifPmOn: "• If Privacy Mode is ON: you can stream content securely",
  ifPmOff: "• If Privacy Mode is OFF: the app will block access to protect your privacy",
  recommended: "Recommended for anyone who wants maximum security and never wants to stream without protection.",
  current_status: "Current Status:",
  pressToDisable: "🛡️ ENABLED - Press to Disable",
  pressToEnable: "○ DISABLED - Press to Enable",
  pressEnter: " Press Enter on the button above to change Kill Switch setting",

  //set pin
  pinSetSuccessfully: "PIN Set Successfully!",
  createPin: "Create your PIN",
  confirmPin: "Confirm Your PIN",
  confirmYourPin: "confirmPin: 'Confirm Your PIN'",
  initializingPin: "Initializing PIN setup...",
  enterCurrentPin: "Enter Current PIN",
  enterNewPin: "Enter New PIN",
  confirmNewPin: "Confirm New PIN",
  pinChanged: "PIN Changed Successfully!",
  pinHasChanged: " Your PIN has been changed successfully!",

  //lastones
  playInfo: "Playlist Info",
  playName: "Playlist Name:",
  host: "Host:",
  username: "Username:",
  password: "Password:",
  packName: "Package Name:",
  expireDate: "Expire Date:",

  //privacyPolicy
  one: "1. Content Disclaimer: OrbixPlay is a platform designed to enhance your digital experience. However, it is important to note that OrbixPlay does not host, provide, or distribute video content. Our service is structured to support your digital journey, but we do not bear responsibility for the availability, quality, or content of video material, as this is outside the scope of our services.",
  two: "2. No Liability for Third-Party Content: OrbixPlay LLC is not liable for any third-party content you may access through our application. Your engagement with any external content, including its legality, reliability, or appropriateness, is solely at your own risk.",
  three:
    "3. Jurisdiction and Compliance: OrbixPlay LLC operates under the jurisdiction of the United States. Users are responsible for ensuring their use of the application is in compliance with all local, state, and federal laws.",
  four: "4. Pricing Policy: Prices for OrbixPlay’s services are subject to change at any time without prior notice. By accepting this agreement, you acknowledge and agree that pricing may vary and that any such changes will not affect your current service until the renewal of your subscription.",
  five: `5. No Warranty: The OrbixPlay application and its services are provided "as is" without any express or implied warranties, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.`,
  six: "6. Acceptance of Terms: By clicking Agree, you agree to be bound by the terms of this disclaimer and acknowledge that any violation may result in termination of your access to OrbixPlay services.",
  orbixUserAgreement: "ORBIXPLAY USER AGREEMENT AND DISCLAIMER",
  beforeyouProcc: "Before you proceed, please read and accept the following terms and conditions:",

  //additional
  exitApp: "Exit OrbixPlay",
  wantToExit: "Are you sure you want to exit OrbixPlay?",
  Resume: "Resume",

  whatsnewinv: "What's New in v",
  whatsnew: "What's New",

  resellerInfiniteDevices: "Reseller Plan: Unlimited Devices",
  resellerInfiniteDevicesDesc: "The same playlist can now be installed on unlimited devices — not 5, not 10, but as many as you need.",
  thankyouforusingorbixplayenjoythenewfeatures: "Thank you for using OrbixPlay — enjoy the new features!",

  instanthomescreen: "Continue Watching",
  instanthomescreendesc: "Resume your series and movies right where you left off.",
  turbomoviesearch: "Favorites Feature",
  turbomoviesearchdesc: "Save your favorite content for quick and easy access anytime.",
  lighterondataandbattery: "Enhanced Player Stability",
  lighterondataandbatterydesc: "Improved playback reliability and smoother seek operations.",
  underthehoodfixes: "Under-the-Hood Fixes",
  underthehoodfixesdesc: "Various bug fixes and performance improvements for a better experience.",

  proxyMaintenance: 'Proxy Maintenance',
  proxyMaintenanceMessage: 'The proxy server is currently under maintenance. Please try again later.',

  playlistInformation: 'Playlist Information',
  playlistExpDate: 'Playlist Expiration Date: ',

  select_playlist: "Select Playlist",
  choose_playlist: " Choose a playlist to start watching",
  invalid_line: "Invalid Line",
  expire_date: "Expire Date:",
  expired: "Expired",

  waiting_connection: "Waiting for connection...",
  reconnection_attempt: "Reconnection attempt",
  try_again: "Try Again",
  go_back: "Go Back",
  unable_to_resume: "Unable to Resume",
  reconnecting: "Reconnecting...",
  no_internet_connection: "No Internet Connection",
  please_try_again: "We could not restart the stream. Please try again.",
  restore_stream: "Please wait while we restore your stream.",
  reconnect_automatically: "Please check your network and we will reconnect automatically.",
  check_wifi: "Check your WiFi connection",
  check_ethernet: "Check your Ethernet / LAN connection",
  check_internet: "Check your internet connection",

  //add playlist screen
  add_playlist_screen: "Add Playlist",
  add_playlist: "Add playlist manually",
  playlist_name_required: "Playlist Name is required",
  m3u_url_required: "M3U Playlist URL is required",
  server_url_required: "Server URL is required",
  username_required: "Username is required",
  password_required: "Password is required",
  orbix_code_required: "Orbix Host Code is required",
  list_code_required: "List Code is required",
  device_id_required: "Device ID is required",
  device_id: "Device ID : ",
  playlist_format: "Playlist Format",
  m3u: "M3U URL",
  username_password: "Username / Password",
  orbix_code: "Orbix Code",
  list_code: "List Code",
  playListName: "Playlist Name *",
  m3uUrl: " M3U Playlist URL *",
  server_URL: "Server URL *",
  username_req: "Username *",
  password_req: "Password *",
  orbix_code_req: "Orbix Host Code *",
  list_code_req: "List Code *",
  addPlaylist: "Add Playlist",
  adding: "Adding...",
  my_playlist: "My Playlist",
  username_placeholder: "username",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Stream Extension",

  //storage_and_data
  storage_and_data: "Storage & Data",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Enter Parental PIN",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Status",
  active: "Active",
  expiration: "Expiration",
  max_connections: "Max Connections",
  one_device: "1 Device",
  created: "Created",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Storage & Data",
  section_subtitle: "Manage your stored app data",
  favourites_label: "Favourites",
  history_label: "Watch History",
  cleared_label: "Cleared",
  all_cleared_label: "All Cleared",
  remove_cancel_label: "Cancel",
  remove_confirm_label: "Clear",
  clear_fav_channels_title: "Favorite Channels",
  clear_fav_channels_subtitle: "Remove all saved channels",
  clear_fav_channels_message: "Clear all favorite channels?",
  clear_fav_movies_title: "Favorite Movies",
  clear_fav_movies_subtitle: "Remove all saved movies",
  clear_fav_movies_message: "Clear all favorite movies?",
  clear_fav_series_title: "Favorite Series",
  clear_fav_series_subtitle: "Remove all saved series",
  clear_fav_series_message: "Clear all favorite series?",
  clear_continue_watching_movies_title: "Continue Watching – Movies",
  clear_continue_watching_movies_subtitle: "Remove movie watch progress",
  clear_continue_watching_series_title: "Continue Watching – Series",
  clear_continue_watching_series_subtitle: "Remove series watch progress",
  clear_continue_watching_title: "Continue Watching",
  clear_continue_watching_message: "Clear watch history?",
  clear_all_title: "Clear All Data",
  clear_all_message: "This will clear all favorites and watch history.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Choose how live streams are requested from your server.",
  ts_desc: "Standard MPEG-TS stream",
  m3u8_desc: "HLS adaptive stream",
  current: "Current",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Access Restricted",
  to_access_playlists: "To access playlists:",
  enable_privacy_mode_step: "1. Enable Privacy Mode from the main screen",
  disable_kill_switch_step: "2. Or disable Kill Switch in Settings → Kill Switch",
  preparingContent: "Preparing your content",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Loading",
  live_now: "LIVE NOW",
  news: "NEWS",
  sport: "SPORT",
  kids: "KIDS",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Episode",
  no_episodes: "There are no episodes available for this season.",

  searchForChannels: "Search for channels...",
  kbSpace: "Space",
  kbCaps: "Caps",
  pressOkToPlay: "Press OK to play",
  live: "Live",
};

export default dict;
